export default "__VITE_ASSET__2101c5d0__"